// // src/pages/ListingDetailPage.tsx
// import React, { useEffect, useState } from "react";
// import { Link, useParams } from "react-router-dom";
// import { ArrowLeft, MapPin, Calendar, Navigation, ShoppingCart, Check } from "lucide-react";
// import { getBrandListingById } from "../services/Brandlistings.api";
// import { BrandListing } from "../types/brandlistingsmodel";
// import { LandingStyles } from "../components/landing/LandingStyles";
// import { LandingHeader } from "../components/landing/LandingHeader";
// import { Footer } from "../components/landing/Footer";
// import { ListingImage } from "../components/landing/ListingImage";
// import { mediaIcon } from "../components/landing/mediaIcons";
// import { useCart } from "../context/CartContext";
// import {
//   formatINR,
//   availabilityLabel,
//   mediaTypeLabel,
//   hasValidCoordinates,
//   googleMapsLink,
// } from "../utils/listingFormat";

// export default function ListingDetailPage() {
//   const { id } = useParams<{ id: string }>();
//   const [listing, setListing] = useState<BrandListing | null>(null);
//   const [isLoading, setIsLoading] = useState(true);
//   const [error, setError] = useState<string | null>(null);
//   const [added, setAdded] = useState(false);
//   const cart = useCart();

//   useEffect(() => {
//     if (!id) return;
//     let cancelled = false;
//     setIsLoading(true);
//     getBrandListingById(id)
//       .then((res) => {
//         if (!cancelled) setListing(res);
//       })
//       .catch((err: Error) => {
//         if (!cancelled) setError(err.message || "Could not load this listing.");
//       })
//       .finally(() => {
//         if (!cancelled) setIsLoading(false);
//       });
//     return () => {
//       cancelled = true;
//     };
//   }, [id]);

//   const handleAddToCart = () => {
//     if (!listing) return;
//     (cart as any).addItem?.(listing) ?? (cart as any).addToCart?.(listing);
//     setAdded(true);
//     setTimeout(() => setAdded(false), 1600);
//   };

//   return (
//     <div className="adroj-landing min-h-screen bg-white text-[#0F172A]">
//       <LandingStyles />
//       <LandingHeader />

//       <div className="mx-auto max-w-5xl px-5 py-8 sm:px-8">
//         <Link to="/" className="inline-flex items-center gap-1.5 text-sm font-semibold text-slate-500 hover:text-[#0F172A]">
//           <ArrowLeft className="h-4 w-4" /> Back to all spaces
//         </Link>

//         {isLoading && <div className="mt-8 animate-pulse text-slate-400">Loading listing...</div>}
//         {error && <div className="mt-8 rounded-xl border border-red-200 bg-red-50 p-6 text-sm text-red-600">{error}</div>}

//         {listing && (
//           <div className="mt-6 grid gap-8 lg:grid-cols-5">
//             <div className="lg:col-span-3">
//               <div className="aspect-[4/3] w-full overflow-hidden rounded-2xl bg-slate-100">
//                 <ListingImage photos={listing.photos} alt={listing.title} className="h-full w-full object-cover" />
//               </div>
//               {listing.photos.length > 1 && (
//                 <div className="mt-3 grid grid-cols-4 gap-3">
//                   {listing.photos.slice(0, 4).map((p, i) => (
//                     <div key={i} className="aspect-square overflow-hidden rounded-lg bg-slate-100">
//                       <img src={p} alt={`${listing.title} ${i + 1}`} className="h-full w-full object-cover" />
//                     </div>
//                   ))}
//                 </div>
//               )}

//               <h2 className="mt-6 text-base font-semibold text-[#0F172A]">About this space</h2>
//               <p className="mt-2 text-sm leading-relaxed text-slate-600">{listing.description}</p>

//               {listing.locationType.description && (
//                 <>
//                   <h2 className="mt-6 text-base font-semibold text-[#0F172A]">{listing.locationType.name}</h2>
//                   <p className="mt-2 text-sm leading-relaxed text-slate-600">{listing.locationType.description}</p>
//                 </>
//               )}
//             </div>

//             <div className="lg:col-span-2">
//               <div className="flex items-center gap-2 rounded-full bg-slate-100 px-3 py-1.5 text-xs font-semibold text-slate-700 w-fit">
//                 {React.createElement(mediaIcon(listing.mediaType), { className: "h-3.5 w-3.5" })}
//                 {mediaTypeLabel(listing.mediaType)}
//               </div>
//               <h1 className="font-display mt-3 text-2xl text-[#0F172A]">{listing.title}</h1>
//               <p className="mt-1 flex items-center gap-1 text-sm text-slate-500">
//                 <MapPin className="h-4 w-4" /> {listing.area}, {listing.city}, {listing.state}
//               </p>
//               {listing.landmark && <p className="mt-0.5 text-xs text-slate-400">Near {listing.landmark}</p>}

//               <p className="mt-3 flex items-center gap-1.5 text-sm text-slate-600">
//                 <Calendar className="h-4 w-4" /> {availabilityLabel(listing.availableFrom, listing.availableTo)}
//               </p>

//               {hasValidCoordinates(listing.latitude, listing.longitude) && (
//                 <a
//                   href={googleMapsLink(listing.latitude, listing.longitude)}
//                   target="_blank"
//                   rel="noreferrer"
//                   className="mt-3 inline-flex items-center gap-1.5 text-sm font-semibold text-[#1170A3] hover:underline"
//                 >
//                   <Navigation className="h-4 w-4" /> View on Google Maps
//                 </a>
//               )}

//               <div className="mt-6 rounded-2xl border border-slate-200 bg-[#F8FAFD] p-5">
//                 <div className="flex items-center justify-between text-sm text-slate-500">
//                   <span>Provider rent</span>
//                   <span>{formatINR(listing.priceBreakdown.providerRent)}</span>
//                 </div>
//                 <div className="mt-1.5 flex items-center justify-between text-sm text-slate-500">
//                   <span>GST ({listing.priceBreakdown.gstPercent}%)</span>
//                   <span>{formatINR(listing.priceBreakdown.gstAmount)}</span>
//                 </div>
//                 <div className="mt-3 flex items-center justify-between border-t border-slate-200 pt-3">
//                   <span className="text-sm font-semibold text-[#0F172A]">Total payable</span>
//                   <span className="font-display text-2xl text-[#0F172A]">{formatINR(listing.priceBreakdown.totalPayable)}</span>
//                 </div>

//                 <button
//                   onClick={handleAddToCart}
//                   className={`mt-5 flex w-full items-center justify-center gap-2 rounded-full px-4 py-3 text-sm font-semibold transition-colors ${
//                     added ? "bg-emerald-500 text-white" : "bg-[#EB4A2D] text-white hover:opacity-90"
//                   }`}
//                 >
//                   {added ? <Check className="h-4 w-4" /> : <ShoppingCart className="h-4 w-4" />}
//                   {added ? "Added to cart" : "Add to cart"}
//                 </button>
//                 <Link
//                   to="/cart"
//                   className="mt-3 flex w-full items-center justify-center rounded-full border border-slate-200 px-4 py-3 text-sm font-semibold text-slate-700 hover:border-slate-300"
//                 >
//                   View cart
//                 </Link>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>

//       <Footer />
//     </div>
//   );
// }

//===================================



// src/pages/ListingDetailPage.tsx
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, MapPin, Calendar, Navigation, ShoppingCart, Check } from "lucide-react";
import { getBrandListingById } from "../services/Brandlistings.api";
import { BrandListing } from "../types/brandlistingsmodel";
import { LandingStyles } from "../components/landing/LandingStyles";
import { LandingHeader } from "../components/landing/LandingHeader";
import { Footer } from "../components/landing/Footer";
import { ListingImage } from "../components/landing/ListingImage";
import { mediaIcon } from "../components/landing/mediaIcons";
import { useCart } from "../context/CartContext";
import { AdSpace } from "../types";
import {
  formatINR,
  availabilityLabel,
  mediaTypeLabel,
  hasValidCoordinates,
  googleMapsLink,
} from "../utils/listingFormat";

export default function ListingDetailPage() {
  const { id } = useParams<{ id: string }>();
  const [listing, setListing] = useState<BrandListing | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [added, setAdded] = useState(false);
  const cart = useCart();

  useEffect(() => {
    if (!id) return;
    let cancelled = false;
    setIsLoading(true);
    getBrandListingById(id)
      .then((res) => {
        if (!cancelled) setListing(res);
      })
      .catch((err: Error) => {
        if (!cancelled) setError(err.message || "Could not load this listing.");
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [id]);

  const handleAddToCart = () => {
    if (!listing) return;
    // See ListingCard.tsx for why this cast is deliberate.
    cart.addToCart(listing as unknown as AdSpace);
    setAdded(true);
    setTimeout(() => setAdded(false), 1600);
  };

  return (
    <div className="adroj-landing min-h-screen bg-white text-[#0F172A]">
      <LandingStyles />
      <LandingHeader />

      <div className="mx-auto max-w-5xl px-5 py-8 sm:px-8">
        <Link to="/" className="inline-flex items-center gap-1.5 text-sm font-semibold text-slate-500 hover:text-[#0F172A]">
          <ArrowLeft className="h-4 w-4" /> Back to all spaces
        </Link>

        {isLoading && <div className="mt-8 animate-pulse text-slate-400">Loading listing...</div>}
        {error && <div className="mt-8 rounded-xl border border-red-200 bg-red-50 p-6 text-sm text-red-600">{error}</div>}

        {listing && (
          <div className="mt-6 grid gap-8 lg:grid-cols-5">
            <div className="lg:col-span-3">
              <div className="aspect-[4/3] w-full overflow-hidden rounded-2xl bg-slate-100">
                <ListingImage photos={listing.photos} alt={listing.title} className="h-full w-full object-cover" />
              </div>
              {listing.photos.length > 1 && (
                <div className="mt-3 grid grid-cols-4 gap-3">
                  {listing.photos.slice(0, 4).map((p, i) => (
                    <div key={i} className="aspect-square overflow-hidden rounded-lg bg-slate-100">
                      <img src={p} alt={`${listing.title} ${i + 1}`} className="h-full w-full object-cover" />
                    </div>
                  ))}
                </div>
              )}

              <h2 className="mt-6 text-base font-semibold text-[#0F172A]">About this space</h2>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">{listing.description}</p>

              {listing.locationType.description && (
                <>
                  <h2 className="mt-6 text-base font-semibold text-[#0F172A]">{listing.locationType.name}</h2>
                  <p className="mt-2 text-sm leading-relaxed text-slate-600">{listing.locationType.description}</p>
                </>
              )}
            </div>

            <div className="lg:col-span-2">
              <div className="flex items-center gap-2 rounded-full bg-slate-100 px-3 py-1.5 text-xs font-semibold text-slate-700 w-fit">
                {React.createElement(mediaIcon(listing.mediaType), { className: "h-3.5 w-3.5" })}
                {mediaTypeLabel(listing.mediaType)}
              </div>
              <h1 className="font-display mt-3 text-2xl text-[#0F172A]">{listing.title}</h1>
              <p className="mt-1 flex items-center gap-1 text-sm text-slate-500">
                <MapPin className="h-4 w-4" /> {listing.area}, {listing.city}, {listing.state}
              </p>
              {listing.landmark && <p className="mt-0.5 text-xs text-slate-400">Near {listing.landmark}</p>}

              <p className="mt-3 flex items-center gap-1.5 text-sm text-slate-600">
                <Calendar className="h-4 w-4" /> {availabilityLabel(listing.availableFrom, listing.availableTo)}
              </p>

              {hasValidCoordinates(listing.latitude, listing.longitude) && (
                <a
                  href={googleMapsLink(listing.latitude, listing.longitude)}
                  target="_blank"
                  rel="noreferrer"
                  className="mt-3 inline-flex items-center gap-1.5 text-sm font-semibold text-[#1170A3] hover:underline"
                >
                  <Navigation className="h-4 w-4" /> View on Google Maps
                </a>
              )}

              <div className="mt-6 rounded-2xl border border-slate-200 bg-[#F8FAFD] p-5">
                <div className="flex items-center justify-between text-sm text-slate-500">
                  <span>Provider rent</span>
                  <span>{formatINR(listing.priceBreakdown.providerRent)}</span>
                </div>
                <div className="mt-1.5 flex items-center justify-between text-sm text-slate-500">
                  <span>GST ({listing.priceBreakdown.gstPercent}%)</span>
                  <span>{formatINR(listing.priceBreakdown.gstAmount)}</span>
                </div>
                <div className="mt-3 flex items-center justify-between border-t border-slate-200 pt-3">
                  <span className="text-sm font-semibold text-[#0F172A]">Total payable</span>
                  <span className="font-display text-2xl text-[#0F172A]">{formatINR(listing.priceBreakdown.totalPayable)}</span>
                </div>

                <button
                  onClick={handleAddToCart}
                  className={`mt-5 flex w-full items-center justify-center gap-2 rounded-full px-4 py-3 text-sm font-semibold transition-colors ${
                    added ? "bg-emerald-500 text-white" : "bg-[#EB4A2D] text-white hover:opacity-90"
                  }`}
                >
                  {added ? <Check className="h-4 w-4" /> : <ShoppingCart className="h-4 w-4" />}
                  {added ? "Added to cart" : "Add to cart"}
                </button>
                <Link
                  to="/cart"
                  className="mt-3 flex w-full items-center justify-center rounded-full border border-slate-200 px-4 py-3 text-sm font-semibold text-slate-700 hover:border-slate-300"
                >
                  View cart
                </Link>
              </div>
            </div>
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
}